export enum U_TAG_METHOD {
  LINK = "link",
  VIEW = "view",
}

export enum EVENT_NAME {
  CLICK_ACTION = "click_action",
  CLICK_CATEGORY = "click_category",
}

export enum CATEGORY {
  CORE_PLUS_PORTAL = "core_plus_portal",
  USER_MANUAL_LINK = "userManual_link",
  SMART_NEXT_STEPS = "smart_next_steps",
  DROP_DOWN = "drop_down",
  PATH_TO_BRONZE = "path_to_bronze",
  TWO_TIME_CASH_INCENTIVE = "two_time_cash_incentive",
  GLOBAL_CML = "global_cml",
  GLOBAL_CML_OVERVIEW = "global_cml_overview",
  GLOBAL_CUSTOMER_PROFILE = "global_cml_profile",
  GLOBAL_CUSTOMER_LIST = "global_cml_customer_list",
  GLOBAL_ORDER_HISTORY = "global_cml_order_history",
  BRONZE_TRACKING = "bronze_tracking",
  OVERVIEW = "overview",
  HAT = "hat",
  GLOBAL_CML_EXPORT = "global_cml_export",
  MY_PERFORMANCE_DASH = "myPerformance_dashboard",
  ANNUAL_PERF_DASH = "annualPerformance_dashboard",
  MBI = "MBI",
  ILB = "ILB",
  FRONTLINE_GROUP_GROWTH = "frontline_group_growth",
  PERSONAL_GROUP_GROWTH = "personal_group_growth",
  ABO_PROFILE = "ABO_profile",
  ACADEMY = "academy",
  STRONG_START_INCENTIVE = "strong_start_incentive",
  PATH_TO_BRONZE_INCENTIVE = "path_to_bronze_incentive",
  BRONZE_FOUNDATION_INCENTIVE = "bronze_foundation_incentive",
  BRONZE_BUILDER_INCENTIVE = "bronze_builder_incentive",
  LEADERSHIP_SEMINAR = "leadership_seminar",
  PERFORMANCE_PLUS_ELITE = "performance_plus_and_elite",
  PERFORMANCE_PLUS = "performance_plus",
  QC_GROWTH = "QC_growth",
  BIRTHDAYS_AR = "birthdays_ar_export",
  GOALS_AR = "goals_ar_export",
  PROVISIONAL_AR = "provisional_ar_export",
  CBR_AR = "cbr_ar_export",
  CVR_AR = "cvr_ar_export",
  WATCHLIST = "watchlist_export",
  WHOSNEW = "whos_new_export",
  WHOS_CLOSE = "whos_close_export",
  NON_BONUSABLE_BV_AR = "non_bonusable_bv_ar_export",
  RENEWALS = "renewals_ar_export",
  LOS = "los_export",
  MONTHLY_Q = "monthly_q",
  Q_GROWTH_INCENTIVE = "q_growth_incentive",
  ECV2 = "earnings_calculator",
  VISION_BONUS = "vision_bonus",
  HEALTH_AND_WELLBEING = "health_and_wellbeing",
  ANNUAL_Q_INCENTIVE = "annual_Q_incentive",
  Frontline_Q = "frontline_q",
  SSI_UPLINE_REPORT = "ssi_upline_report",
  RETRO_PV_INQUIRY = "retro_pv_inquiry",
  DIAMOND_BONUS = "100_diamond",
  BIRTHDAYS = "birthdays",
  ACTION_REPORT = "action_report",
  WHOS_CLOSE_AR = "whos_close",
  IBO_ONBOARDING_AR = "IBO_onboarding",
  NBBV_AR = "non_bonusable_bv",
  WATCHLIST_AR = "watchlist",
  WHOS_NEW_AR = "whos_new_action-report",
  RENEWALS_AR = "renewals-action-report",
  SAQ_AR = "SAQ",
  FSI_AR = "founders_sales_incentive-report",
  ONLINE_STATEMENT = "online_statement",
  GROUP_MANAGEMENT = "group_management",
  PERFORMANCE_DASHBOARD = "performance_dashboard",
  HAT_LEGS_TRACKING = "hat_legs_tracking",
  GAR_TRACKING = "gar_tracking",
  FAA = "faa",
  FOUNDERS_SALES_INCENTIVE = "founders_sales_incentive",
}

export enum SECTION {
  PERFORMANCE_BONUS_PERCENT_LEGS = "performance_bonus_percent_legs",
  PERFORMANCE_BONUS_PERCENT_LEG_WITH_VCS_PV = "performance_bonus_percent_leg_with_vcs_pv",
  ELIGIBILITY_TILE = "eligibility_tile",
  BANNER_CTA = "banner_cta",
  STRONG_START_INCENTIVE = "strong_start_incentive",
  MONTHLY_GPV_STATUS_MODAL = "monthly_gpv_status_modal",
  QC_GROWTH = "QC_growth",
  EXPORT_MODAL = "export_modal",
  EXPORT_ANOTHER_MODAL = "export_download_modal",
  EC = "earnings_calculator",
  KPI = "kpi",
  BONUS_DETAILS = "bonus_details",
  ABO_LEGS = "abo_legs",
  GLOBAL_CUSTOMER_LIST = "global_cml_customer_list",
  GLOBAL_ORDER_HISTORY = "global_cml_order_history",
  EXPORT_DOWNLOAD_MODAL = "export_download_modal",
  LEADERSHIP_SEMINAR = "leadership_seminar",
  LEADERSHIP_SEMINAR_VOLUME_DETAILS = "maintain_leadership_seminar_volume",
  Q_MONTHS_TILE = "Q_months_tile",
  ANNUAL_DASHBOARD = "annual_dashboard",
  MONTHLY_DASHBOARD = "monthly_dashboard",
  PERFORMANCE_AND_INCOME = "performance_&_income",
  REQUIREMENT_TRACKING = "requirement_tracking",
}

const tealiumEnums = {
  U_TAG_METHOD,
  EVENT_NAME,
  CATEGORY,
  SECTION,
};

export default tealiumEnums;
